import { Committee } from '@/models';

export const orderedCommittees = [
  Committee.japan,
  Committee.america,
  Committee.europe_others,
  Committee.asia_others,
  Committee.korea,
  Committee.china,
  Committee.france
];

export const committees = {
  [Committee.japan]: {
    label: 'home.map.selectionJapan',
    deadline: 'march2025',
    email: 'japon@championnatdumondeduchoufarci.com'
  },
  [Committee.china]: {
    label: 'home.map.selectionChina',
    deadline: 'septemberOctober2025',
    email: 'china@championnatdumondeduchoufarci.com'
  },
  [Committee.asia_others]: {
    label: 'home.map.selectionAsia',
    deadline: 'septemberOctober2025',
    email: 'apac@championnatdumondeduchoufarci.com'
  },
  [Committee.europe_others]: {
    label: 'home.map.selectionEurope',
    deadline: 'october2025',
    email: 'emea@championnatdumondeduchoufarci.com'
  },
  [Committee.america]: {
    label: 'home.map.selectionAmericas',
    deadline: 'june2025',
    email: 'americas@championnadumondeduchoufarci.com'
  },
  [Committee.france]: {
    label: 'home.map.selectionFrance',
    deadline: 'september2025',
    email: 'france@championnatdumondeduchoufarci.com'
  },
  [Committee.korea]: {
    label: 'home.map.selectionKorea',
    deadline: 'septemberOctober2025',
    email: 'korea@championnatdumondeduchoufarci.com'
  }
};
